import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { datadogRum } from "@datadog/browser-rum";

function useSetDatadogUser() {
  const { authState } = useOktaAuth();
  const oktaId = authState?.idToken?.claims.sub as string | undefined;

  useEffect(() => {
    if (authState?.isAuthenticated && oktaId) {
      datadogRum.setUser({ id: oktaId });
      window.heap?.identify(oktaId);
    } else if (!authState?.isAuthenticated) {
      datadogRum.clearUser();
      window.heap?.resetIdentity();
    }
  }, [authState?.isAuthenticated, oktaId]);
}

export default useSetDatadogUser;
